import client from '@js/client'
import resources from '@js/resources'
import { snakeKeyToCamelKeyRecursive } from '@js/str-utils'


const getDefaultState = () => {
  return {
    initialized: false,
    data: {},
  };
};

const tenantDiagnose = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    set (state, data) {
      state.data = data;
      state.initialized = true;
    },
  },
};

export default tenantDiagnose;
